/* src/app/home-new/tooltip-info-components/tooltip-info-folders/tooltip-info-folders.component.scss */
h2 {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 600;
  font-size: 18px;
}
p {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 400;
  font-size: 14px;
}
/*# sourceMappingURL=tooltip-info-folders.component-3TIWG2Q7.css.map */
